import { Link, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import SwiperCore, { Autoplay } from "swiper/core";
import { useEffect, useState } from "react";
import axios from "axios";
import CampaignIcon from "@mui/icons-material/Campaign";
import AnimatedPage from "../components/AnimatedPage";
import swal from "sweetalert";

function Home() {
    SwiperCore.use([Autoplay]);
    const swiperParams = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        }
    };
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    //const [isShow, setShow] = useState(false);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [bet, setBet] = useState(JSON.parse(localStorage.getItem("xsmb")));
    const [loadGame, setLoadGame] = useState(false);
    //const [total, setTotal] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (notify != res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });
        axios.get(`https://mu88.live/api/front/open/lottery/history/list/1/miba`).then((res) => {
            setBet(res.data.t);
            if (bet != res.data.t) {
                setBet(res.data.t);
                localStorage.setItem("xsmb", JSON.stringify(res.data.t));
            }
            /*setTotal([
                {
                    dacbiet: JSON.parse(res.data.t.issueList[0].detail)[0],
                    nhat: JSON.parse(res.data.t.issueList[0].detail)[1],
                    hai: JSON.parse(res.data.t.issueList[0].detail)[2].split(",").join(" "),
                    ba: JSON.parse(res.data.t.issueList[0].detail)[3].split(",").join(" "),
                    tu: JSON.parse(res.data.t.issueList[0].detail)[4].split(",").join(" "),
                    nam: JSON.parse(res.data.t.issueList[0].detail)[5].split(",").join(" "),
                    sau: JSON.parse(res.data.t.issueList[0].detail)[6].split(",").join(" "),
                    bay: JSON.parse(res.data.t.issueList[0].detail)[7].split(",").join(" ")
                }
            ]);*/
        });
        axios.get(`${process.env.REACT_APP_API_URL}/casino/create`);
        /*axios.post(`${process.env.REACT_APP_API_URL}/casino/getlist`, {provider: "AG"}).then((res) => {
            console.log(JSON.parse(res.data.data.gamelist))
        });*/
    }, []);
    const [activeOption, setActiveOption] = useState("1");
    const handleOptionClick = (option) => {
        setActiveOption(option);
    };
    const date0 = new Date();
    const currentHour = date0.getHours();
    const [dateMT, setDateMT] = useState(date0.getDay());
    const [dataMT, setDataMT] = useState();
    const [imageMT, setImageMT] = useState([]);
    const handleChangeMT = (e) => {
        setDateMT(e.target.value);
    };
    const [dateMN, setDateMN] = useState(date0.getDay());
    const [dataMN, setDataMN] = useState([]);
    const [imageMN, setImageMN] = useState([]);
    const handleChangeMN = (e) => {
        setDateMN(e.target.value);
    };
    useEffect(() => {
        if (dateMT == 0) {
            if (currentHour < 18) {
                setDataMT(["khho", "kotu", "thth"]);
                setImageMT(["khanhhoa", "komtum", "hue"]);
            } else {
                setDataMT(["phye", "thth"]);
                setImageMT(["phuyen", "hue"]);
            }
        }
        if (dateMT == 1) {
            if (currentHour < 18) {
                setDataMT(["phye", "thth"]);
                setImageMT(["phuyen", "hue"]);
            } else {
                setDataMT(["dalak", "quna"]);
                setImageMT(["daklak", "quangnam"]);
            }
        }
        if (dateMT == 2) {
            if (currentHour < 18) {
                setDataMT(["dalak", "quna"]);
                setImageMT(["daklak", "quangnam"]);
            } else {
                setDataMT(["dana", "khho"]);
                setImageMT(["danang", "khanhhoa"]);
            }
        }
        if (dateMT == 3) {
            if (currentHour < 18) {
                setDataMT(["dana", "khho"]);
                setImageMT(["danang", "khanhhoa"]);
            } else {
                setDataMT(["qubi", "bidi", "qutr"]);
                setImageMT(["quangbinh", "binhdinh", "quangtri"]);
            }
        }
        if (dateMT == 4) {
            if (currentHour < 18) {
                setDataMT(["qubi", "bidi", "qutr"]);
                setImageMT(["quangbinh", "binhdinh", "quangtri"]);
            } else {
                setDataMT(["gila", "nith"]);
                setImageMT(["gialai", "ninhthuan"]);
            }
        }
        if (dateMT == 5) {
            if (currentHour < 18) {
                setDataMT(["gila", "nith"]);
                setImageMT(["gialai", "ninhthuan"]);
            } else {
                setDataMT(["dana", "qung", "dano"]);
                setImageMT(["danang", "quangngai", "daknong"]);
            }
        }
        if (dateMT == 6) {
            if (currentHour < 18) {
                setDataMT(["dana", "qung", "dano"]);
                setImageMT(["danang", "quangngai", "daknong"]);
            } else {
                setDataMT(["khho", "kotu", "thth"]);
                setImageMT(["khanhhoa", "komtum", "hue"]);
            }
        }
    }, [dateMT]);
    useEffect(() => {
        if (dateMN == 0) {
            if (currentHour < 17) {
                setDataMN(["dalat", "kigi", "tigi"]);
                setImageMN(["dalat", "kiengiang", "tiengiang"]);
            } else {
                setDataMN(["cama", "doth", "tphc"]);
                setImageMN(["camau", "dongthap", "tphcm"]);
            }
        }
        if (dateMN == 1) {
            if (currentHour < 17) {
                setDataMN(["cama", "doth", "tphc"]);
                setImageMN(["camau", "dongthap", "tphcm"]);
            } else {
                setDataMN(["bali", "vuta", "betr"]);
                setImageMN(["baclieu", "vungtau", "bentre"]);
            }
        }
        if (dateMN == 2) {
            if (currentHour < 17) {
                setDataMN(["bali", "vuta", "betr"]);
                setImageMN(["baclieu", "vungtau", "bentre"]);
            } else {
                setDataMN(["cath", "dona", "sotr"]);
                setImageMN(["cantho", "dongnai", "soctrang"]);
            }
        }
        if (dateMN == 3) {
            if (currentHour < 17) {
                setDataMN(["cath", "dona", "sotr"]);
                setImageMN(["cantho", "dongnai", "soctrang"]);
            } else {
                setDataMN(["angi", "bith", "tani"]);
                setImageMN(["angiang", "binhthuan", "tayninh"]);
            }
        }
        if (dateMN == 4) {
            if (currentHour < 17) {
                setDataMN(["angi", "bith", "tani"]);
                setImageMN(["angiang", "binhthuan", "tayninh"]);
            } else {
                setDataMN(["bidu", "trvi", "vilo"]);
                setImageMN(["binhduong", "travinh", "vinhlong"]);
            }
        }
        if (dateMN == 5) {
            if (currentHour < 17) {
                setDataMN(["bidu", "trvi", "vilo"]);
                setImageMN(["binhduong", "travinh", "vinhlong"]);
            } else {
                setDataMN(["biph", "hagi", "loan", "tphc"]);
                setImageMN(["binhphuoc", "haugiang", "longan", "tphcm"]);
            }
        }
        if (dateMN == 6) {
            if (currentHour < 17) {
                setDataMN(["biph", "hagi", "loan", "tphc"]);
                setImageMN(["binhphuoc", "haugiang", "longan", "tphcm"]);
            } else {
                setDataMN(["dalat", "kigi", "tigi"]);
                setImageMN(["dalat", "kiengiang", "tiengiang"]);
            }
        }
    }, [dateMN]);

    function isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    function launchGame(params) {
        const form = {
            ...params,
            mobile: isMobileDevice == true ? 1 : 0,
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/launch`, form)
            .then((res) => {
                if (res.data.data.errMsg == "SUCCESS") {
                    window.location.href = res.data.data.gameUrl;
                } else {
                    swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                }
            })
            .catch((err) => swal("Thất bại", err.response.data.message != "internal server error" ? err.response.data.message : "Đã có lỗi xảy ra", "error"));;
    }
    return (
        <>
            <Header profile={profile} />
            {swiperParams && notify && bet?.issueList && (
                <AnimatedPage>
                    <div className="box-slide" style={{ overflow: "hidden" }}>
                        <Swiper {...swiperParams}>
                            {notify.map((item, index) => (
                                <>
                                    {index > 1 && item.title !== "marquee" && item.isShow === true ? (
                                        <SwiperSlide>
                                            <img alt={item.title.replace("}", "").replace("{", "")} src={item.image} />
                                        </SwiperSlide>
                                    ) : null}
                                </>
                            ))}
                        </Swiper>
                        {notify ? (
                            <>
                                {notify[0].isShow === true && notify[0].title === "marquee" ? (
                                    <div className="marquees">
                                        <div>
                                            <CampaignIcon sx={{ fontSize: "22px" }} />
                                        </div>
                                        <div>
                                            <div
                                                className="chaychu"
                                                style={{ animation: "chuchay " + notify[0].content.length / 10 + "s linear infinite" }}
                                                dangerouslySetInnerHTML={{
                                                    __html: notify[0].content
                                                }}
                                            />
                                        </div>
                                    </div>
                                ) : null}
                            </>
                        ) : null}
                    </div>
                    <div className="box-game">
                        <div className={activeOption === "1" ? "active" : ""} onClick={() => handleOptionClick("1")}>
                            {activeOption === "1" ? <img alt="" src="/images/icon_lotto-act.png" /> : <img alt="" src="/images/icon_lotto.png" />}
                            <span>Xổ số</span>
                        </div>
                        <div className={activeOption === "2" ? "active" : ""} onClick={() => handleOptionClick("2")}>
                            {activeOption === "2" ? <img alt="" src="/images/icon_livecasino-act.png" /> : <img alt="" src="/images/icon_livecasino.png" />}
                            <span>Live Casino</span>
                        </div>
                        <div className={activeOption === "3" ? "active" : ""} onClick={() => handleOptionClick("3")}>
                            {activeOption === "3" ? <img alt="" src="/images/icon_poker-act.png" /> : <img alt="" src="/images/icon_poker.png" />}
                            <span>Game bài</span>
                        </div>
                        <div className={activeOption === "4" ? "active" : ""} onClick={() => handleOptionClick("4")}>
                            {activeOption === "4" ? <img alt="" src="/images/icon_xucsac-act.png" /> : <img alt="" src="/images/icon_xucsac.png" />}
                            <span>Tài xỉu</span>
                        </div>
                        <div className={activeOption === "5" ? "active" : ""} onClick={() => handleOptionClick("5")}>
                            {activeOption === "5" ? <img alt="" src="/images/icon_nohu-act.png" /> : <img alt="" src="/images/icon_nohu.png" />}
                            <span>Nổ hũ</span>
                        </div>
                        <div className={activeOption === "6" ? "active" : ""} onClick={() => handleOptionClick("6")}>
                            {activeOption === "6" ? <img alt="" src="/images/icon_thethao-act.png" /> : <img alt="" src="/images/icon_thethao.png" />}
                            <span>Thể thao</span>
                        </div>
                        <div className={activeOption === "7" ? "active" : ""} onClick={() => handleOptionClick("7")}>
                            {activeOption === "7" ? <img alt="" src="/images/icon_banca-act.png" /> : <img alt="" src="/images/icon_banca.png" />}
                            <span>Bắn cá</span>
                        </div>
                    </div>
                    <div style={{ padding: "0 0.32rem 2rem" }}>
                        <div className="content-game">
                            {activeOption === "1" && (
                                <div className="list-game">
                                    <div className="title" onClick={() => navigate("/xoso")}>
                                        Nổi bật >>
                                    </div>
                                    <div className="box-miba">
                                        <div className="box-miba-left" onClick={() => navigate("/xsmb/lo2")}>
                                            <img alt="" src={require("../../images/3mien/mienbac.png")} />
                                            <div className="dat-cuoc" onClick={() => navigate("/xsmb/lo2")}>
                                                Đặt cược
                                            </div>
                                        </div>
                                        <div className="box-miba-right">
                                            <div className="box-text">
                                                Miền Bắc <img alt="" src={require("../../img/icon-hot.png")} className="icon-hot" />
                                            </div>
                                            <div className="box-text">Ngày: {bet?.issueList[0]?.turnNum}</div>
                                            <div className="box-miba-kq">
                                                {bet?.issueList[0]?.openNum.split(",").map((x) => (
                                                    <div className="ball">
                                                        <img alt="" src={`/images/ball/${x}.png`} />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <div className="title">Trò chơi hot</div>
                                            <div className="list-game-xs">
                                                <Link to="/xs75s/lo2">
                                                    <img alt="" src={require(`../../images/mb75s.png`)} />
                                                </Link>
                                                <Link to="/xs120s/lo2">
                                                    <img alt="" src={require(`../../images/st2p.png`)} />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="title" onClick={() => navigate("/xoso")}>
                                        Miền Nam >>
                                    </div>
                                    <div className="list-game-xs">
                                        {dataMN?.map((item, index) => (
                                            <>
                                                <Link to={`/xsmn/lo2/${item}`} key={item}>
                                                    <img alt="" src={require(`../../images/3mien/${imageMN[index]}.png`)} />
                                                </Link>
                                            </>
                                        ))}
                                    </div>
                                    <div className="title" onClick={() => navigate("/xoso")}>
                                        Miền Trung >>
                                    </div>
                                    <div className="list-game-xs">
                                        {dataMT?.map((item, index) => (
                                            <>
                                                <Link to={`/xsmt/lo2/${item}`} key={item}>
                                                    <img alt="" src={require(`../../images/3mien/${imageMT[index]}.png`)} />
                                                </Link>
                                            </>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {activeOption === "2" && (
                                <>
                                    <div className="api-game" onClick={() => launchGame({ provider: "WC", type: "LC" })}>
                                        <img alt="" src={require("../../images/game/WM_csn.png")} />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "DG", type: "LC" })}>
                                        <img alt="" src={require("../../images/game/Dream_csn.png")} />
                                        <img alt="" src={require("../../images/game/hot.gif")} className="sub_hot" />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "AG", type: "LC" })}>
                                        <img alt="" src={require("../../images/game/AG_csn.png")} />
                                        <img alt="" src={require("../../images/game/hot.gif")} className="sub_hot" />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "P3", type: "LC" })}>
                                        <img alt="" src={require("../../images/game/EG_csn.png")} />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "S2", type: "LC" })}>
                                        <img alt="" src={require("../../images/game/AE_csn.png")} />
                                        <img alt="" src={require("../../images/game/hot.gif")} className="sub_hot" />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "AT", type: "LC" })}>
                                        <img alt="" src={require("../../images/game/ALLBET_csn.png")} style={{ borderRadius: "10px" }} />
                                    </div>
                                </>
                            )}
                            {activeOption === "3" && (
                                <>
                                    <div className="api-game" onClick={() => launchGame({ provider: "V8", type: "CB" })}>
                                        <img alt="" src={require("../../images/games/chess_sub_v8.png")} />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "TP", type: "CB" })}>
                                        <img alt="" src={require("../../images/games/gamebai_tp.png")} />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "KY", type: "CB" })}>
                                        <img alt="" src={require("../../images/games/ky.png")} />
                                    </div>
                                </>
                            )}
                            {activeOption === "4" && (
                                <div class="api-game-flex">
                                    <div style={{ width: "33.33%" }} className="api-game" onClick={() => launchGame({ provider: "WC", type: "LC", gameid: "onlysicbo" })}>
                                        <img alt="" src={require("../../images/games/dice.png")} />
                                        <img alt="" src={require("../../images/game/logo_wm.png")} className="sub_logo" />
                                    </div>
                                    <div style={{ width: "33.33%" }} className="api-game" onClick={() => launchGame({ provider: "WC", type: "LC", gameid: "onlysedie" })}>
                                        <img alt="" src={require("../../images/games/sd.png")} />
                                        <img alt="" src={require("../../images/game/logo_wm.png")} className="sub_logo" />
                                    </div>
                                    <div style={{ width: "33.33%" }} className="api-game" onClick={() => launchGame({ provider: "WC", type: "LC", gameid: "onlydgtg" })}>
                                        <img alt="" src={require("../../images/games/slotLs.png")} />
                                        <img alt="" src={require("../../images/game/logo_wm.png")} className="sub_logo" />
                                    </div>
                                </div>
                            )}
                            {activeOption === "5" && (
                                <div class="api-game-flex">
                                    <div className="api-game" onClick={() => launchGame({ provider: "JL", type: "SL" })}>
                                        <img alt="" src={require("../../images/games/jili.png")} />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "AG", type: "SL" })}>
                                        <img alt="" src={require("../../images/games/slotag.png")} />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "MG", type: "SL" })}>
                                        <img alt="" src={require("../../images/games/mg.png")} />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "GB", type: "SL" })}>
                                        <img alt="" src={require("../../images/games/bbin.png")} />
                                    </div>
                                </div>
                            )}
                            {activeOption === "6" && (
                                <>
                                    <div className="api-game" onClick={() => launchGame({ provider: "IB", type: "SB" })}>
                                        <img alt="" src={require("../../images/game/SABA.png")} />
                                        <img alt="" src={require("../../images/game/hot.gif")} className="sub_hot" />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "SO", type: "SB" })}>
                                        <img alt="" src={require("../../images/game/sbo_b.png")} />
                                        <img alt="" src={require("../../images/game/hot.gif")} className="sub_hot" />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "UG", type: "SB" })}>
                                        <img alt="" src={require("../../images/game/UG.png")} style={{ borderRadius: "10px", width: "100%" }} />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "CM", type: "SB" })}>
                                        <img alt="" src={require("../../images/game/CMD.png")} />
                                    </div>
                                </>
                            )}
                            {activeOption === "7" && (
                                <>
                                    <div className="api-game" onClick={() => launchGame({ provider: "JL", type: "FH" })}>
                                        <img alt="" src={require("../../images/game/JILI_bc.png")} />
                                        <img alt="" src={require("../../images/game/hot.gif")} className="sub_hot" />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "GB", type: "FH" })}>
                                        <img alt="" src={require("../../images/game/bbin_bc.png")} />
                                    </div>
                                    <div className="api-game" onClick={() => launchGame({ provider: "MP", type: "FH" })}>
                                        <img alt="" src={require("../../images/game/MG_bc.png")} />
                                    </div>
                                </>
                            )}
                            {/*activeOption !== "1" && (
                                <div className="baohanh">
                                    <img alt="" src={require("../../images/bao-hanh-va-sua-chua.png")} style={{ maxWidth: "8rem" }} />
                                    <div className="nangcap">Hệ thống đang nâng cấp...</div>
                                </div>
                            )*/}
                        </div>
                    </div>
                </AnimatedPage>
            )}
            <Footer />
        </>
    );
}
export default Home;
